<template>
  <el-dialog
    v-if="visibles"
    v-el-drag-dialog
    :visible.sync="visibles"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :destroy-on-close="true"
    top="8vh"
    :show-close="false"
    center
  >
    <dialog-header
      slot="title"
      :title="
        !isEdit
          ? $t('system.brand.series.addSeries')
          : $t('system.brand.series.editSeries')
      "
      :icon="!isEdit ? 'icon-dialog-add' : 'icon-dialog-update'"
      @close="closeDialog"
    />
    <vue-linetitle>
      <el-form
        ref="form"
        :rules="rulesCenter"
        :model="formInfo"
        label-suffix="："
        label-position="right"
        label-width="auto"
      >
        <el-form-item
          v-for="(item, index) in formItemList"
          :label="$t(`system.brand.series.${item}`)"
          :prop="item"
          :key="index"
        >
          <el-input
            v-model="formInfo[item]"
            clearable
            :placeholder="$t(`system.brand.series.${item}`)"
          />
        </el-form-item>
        <el-form-item :label="$t('system.brand.remark')" prop="remark">
          <el-input
            v-model="formInfo.remark"
            :rows="3"
            :autosize="{ minRows: 3, maxRows: 3 }"
            resize="none"
            :placeholder="$t('system.brand.remark')"
            type="textarea"
            :maxlength="500"
            :show-word-limit="true"
          />
        </el-form-item>
      </el-form>
    </vue-linetitle>
    <span slot="footer" class="dialog-footer">
      <el-button
        v-waves
        class="dialog-cancel"
        type="primary"
        @click="closeDialog"
        >{{ $t("public.cancel") }}</el-button
      >
      <el-button v-waves type="primary" @click="handleSubmit">{{
        $t("public.define")
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
// 混入
import { partialForm } from '@/mixins/partialForm'
// request
import { createUrl, updateUrl, TYPENUMBER } from '@/api/system/carSeries'
export default {
  name: 'AddUpdateDialog',
  mixins: [partialForm],
  props: {
    visibles: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    // 名称
    const validateSeriesName = (rule, value, cb) => {
      if (!this.formInfo.seriesName) return cb(new Error(this.$t('system.brand.series.errorName')))
    }
    // 编码
    const validateSeriesCode = (rule, value, cb) => {
      if (!this.formInfo.seriesCode) return cb(new Error(this.$t('system.brand.series.errorCode')))
    }
    return {
      formInfo: {},
      rulesCenter: {
        seriesName: [
          { required: true, trigger: ['blur', 'change'], validator: validateSeriesName }
        ],
        seriesCode: [
          { required: true, trigger: ['blur', 'change'], validator: validateSeriesCode }
        ]
      },
      formItemList: [
        'seriesName',
        'seriesCode',
      ]
    }
  },
  watch: {
    visibles(e1) {
      if (e1) {
        this.formInfo = { ...this.data }
      }
    }
  },
  methods: {
    // 关闭
    closeDialog() {
      this.$emit('update:visibles', false)
    },
    // 提交
    handleSubmit() {
      const formCheck = this.checkForm({
        formName: 'form',
        formList: ['seriesName', 'seriesCode']
      })
      if (!formCheck) return

      const { seriesName, seriesCode, brandId, seriesId, remark } = this.formInfo
      const postData = {
        name: seriesName,
        code: seriesCode,
        type: TYPENUMBER,
        pid: brandId,
        remark
      }
      if (!this.isEdit) {
        this._createSeries(postData)
      } else {
        postData.id = seriesId
        this._updateSeries(postData)
      }
    },
    // 新增
    _createSeries(postData) {
      this.$http.post(createUrl, postData).then(({ data }) => {
        if (data.code === 0) {
          this.$message.success({
            message: this.$t('public.createSuccess'),
            duration: 2 * 1000
          })
          this.$emit('add-complete')
          this.closeDialog()
        }
      })
    },
    // 编辑
    _updateSeries(postData) {
      this.$http.put(updateUrl, postData).then(({ data }) => {
        if (data.code === 0) {
          this.$message.success({
            message: this.$t('public.updateSuccess'),
            duration: 2 * 1000
          })
          this.$emit('update-complete')
          this.closeDialog()
        }
      })
    }
  }
}
</script>
